// @flow
import * as types from './mutation-types'
import type {OrderItemsState} from '../order-items'
import type {OrderItem} from '../../../types/order-item'

export default {
  [types.SET_ORDER_ITEMS_FOR_CURRENT_FILTER]: (state: OrderItemsState, orderItems: OrderItem[]): void => {
    state.orderItemsForCurrentFilter = orderItems
  },
  [types.SET_TOTAL_NO_ORDER_ITEMS_FOR_CURRENT_FILTER]: (state: OrderItemsState, count: number): void => {
    state.totalNoOrderItemsForCurrentFilter = count
  },
  [types.SET_ORDER_ITEMS_CURRENT_PAGE_NUMBER]: (state: OrderItemsState, { number }: { number: number }): void => {
    state.orderItemsCurrentPageNumber = number
  },
  [types.SET_ORDER_ITEMS_PAGE_SIZE]: (state: OrderItemsState, number: number): void => {
    if (number <= 0) {
      return
    }
    state.orderItemsPageSize = number
    let noPages = Math.ceil(state.totalNoOrderItemsForCurrentFilter / number)
    if (state.orderItemsCurrentPageNumber >= noPages) {
      state.orderItemsCurrentPageNumber = noPages - 1
    }
  },
  [types.SET_ORDER_ITEMS_ORDER_BY]: (state: OrderItemsState, orderBy: ?string): void => {
    state.orderItemsOrderBy = orderBy
  },
  [types.SET_ORDER_ITEMS_ORDER_DIRECTION]: (state: OrderItemsState, orderDirection: ?string): void => {
    state.orderItemsOrderDirection = orderDirection
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order-items/mutations.js